import type { TooltipOptions } from '~/modules/tooltip/types'
import { useTooltip } from '~/modules/tooltip/runtime/composables/useTooltip'

export function usePriceLegalInfoTooltip(options?: TooltipOptions) {
  const trPrefix = 'www.components.hitbox.Price.'

  const { t } = useI18n()

  return useTooltip(
    () =>
      [
        `<b>${t(`${trPrefix}dependentPrice`)}</b>`,
        t(`${trPrefix}priceAfterInput`),
        `<b>${t(`${trPrefix}addCosts`)}</b>`,
        t(`${trPrefix}addCostsLong`),
      ].join('<br/>'),
    options,
  )
}
